import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <section className="bg-stark-white py-24 md:py-32" data-id="element-107">
      <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-20 items-center" data-id="element-108">
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="order-2 md:order-1 bg-midnight-navy p-8 rounded-lg shadow-2xl border border-white/10" data-id="element-109">
          <div className="space-y-6" data-id="element-110">
            <div className="flex justify-between items-end" data-id="element-111">
              <h4 className="text-stark-white/50 text-xs font-bold uppercase tracking-widest" data-id="element-112">
                Operational Audit
              </h4>
              <span className="text-accent-red text-xs font-bold" data-id="element-113">
                Critical Alerts
              </span>
            </div>
            <div className="space-y-4" data-id="element-114">
              {[{
              label: 'Food Costs',
              value: 85,
              color: 'bg-accent-red'
            }, {
              label: 'Labor',
              value: 70,
              color: 'bg-accent-red'
            }, {
              label: 'Utilities',
              value: 45,
              color: 'bg-gray-600'
            }, {
              label: 'Waste',
              value: 90,
              color: 'bg-accent-red'
            }, {
              label: 'Inventory Loss',
              value: 65,
              color: 'bg-accent-red'
            }, {
              label: 'Overspending',
              value: 75,
              color: 'bg-accent-red'
            }].map((item, idx) => <div key={item.label} className="space-y-2" data-id="element-115">
                  <div className="flex justify-between text-xs text-stark-white/80" data-id="element-116">
                    <span data-id="element-117">{item.label}</span>
                    <span data-id="element-118">{item.value}%</span>
                  </div>
                  <div className="h-1 bg-white/10 overflow-hidden" data-id="element-119">
                    <motion.div initial={{
                  width: 0
                }} whileInView={{
                  width: `${item.value}%`
                }} viewport={{
                  once: true
                }} transition={{
                  duration: 1,
                  delay: 0.2 + idx * 0.1,
                  ease: 'circOut'
                }} className={`h-full ${item.color}`} data-id="element-120" />
                  </div>
                </div>)}
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="order-1 md:order-2 space-y-8" data-id="element-121">
          <h2 className="text-midnight-navy text-4xl md:text-5xl font-manrope font-bold leading-tight" data-id="element-122">
            Most Restaurant Owners Know Sales… But Don’t Know What They Actually
            Keep.
          </h2>
          <div className="space-y-6 text-midnight-navy/70 text-lg leading-relaxed" data-id="element-123">
            <p data-id="element-124">
              You might make $20,000 this week… but how much of that is actually
              profit? Between fluctuating ingredient prices, labor
              inefficiencies, and hidden waste, margins are thinner than ever.
            </p>
            <p data-id="element-125">
              Most operators never see the full picture until it’s already
              hurting the business. ROI changes that by providing a real-time
              process audit of your entire operation.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}